var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 10.8333V0H1.66675V20H8.67425C12.7217 20 11.4534 13.3333 11.4534 13.3333C13.9609 13.9542 18.3334 13.6825 18.3334 10.8333ZM15.0001 5H5.00008V4.16667H15.0001V5ZM15.0001 7.5H5.00008V6.66667H15.0001V7.5ZM15.0001 10H5.00008V9.16667H15.0001V10ZM13.2576 15.1858C14.9634 15.5842 17.2617 14.9533 18.3334 14.2033C17.0884 15.8683 13.9751 18.96 12.1401 19.9375C13.1034 18.9642 13.4426 16.4092 13.2576 15.1858Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.a56d3f0af001e316097f70393fe6d5fe.svg";
export { ForwardRef as ReactComponent };